import { NominalAccount } from './nominal-account';
import { DepreciationRule } from './depreciation-rules';
import { AccountGroup } from './account-group';
import { JournalEntry } from './reporting-periods';

export interface AssetBase {
  id: number;
  disposed: boolean;
  depreciationCommencementDeferred: boolean;
  isKitParent: boolean;
  isKitMember: boolean;
  assetState: string;
  canAssetBeDeleted: boolean;
}

export class Asset implements AssetBase {
  id = 0;
  accountGroupId: number;
  nominalAccountId: number;
  depreciationRuleId: number;
  assetName: string;
  description: string;
  createdOn: Date;
  createdBy: string;
  acquiredOn: Date;
  cost: number;
  sourceTransactionRef: string;
  localTransactionId: number;
  broughtForwardCost: number;
  broughtForwardDepreciation: number;
  currentValue: number;
  currentDepreciation: number;
  totalDepToDate: number;
  parentId: number;
  disposed: boolean;
  disposalDate: Date;
  disposalValue: number;
  assetState: string;
  assetRef: string;
  supplierName: string;
  class: string;
  assetImported: boolean;
  assetImportDate: Date;
  assetPeriods: AssetPeriod[] = [];
  depreciationCommenceDate: Date;
  depreciationCommencementDeferred: boolean;
  isKitMember: boolean;
  isKitParent: boolean;
  residualValue: number;
  location: string;
  canAssetBeDeleted: boolean;
    selected: boolean;
    children: any[];
  accountGroup: AccountGroup;
  nominalAccount: NominalAccount;
  depreciationRule: DepreciationRule;
}

export class AssetPeriod {
  id: number;
  assetId: number;
  reportingPeriodId: number;
  depreciation: number;
  closed: boolean;
}

export class AssetPeriodModel {
    id:number;
    periodPostingDate: Date;
    periodType: string;
    depreciation: number;
    closed: boolean;
    financialYearId: number;
    
}

export class AssetAudit {

}

export class AssetDisposalModel {
  assetId: number;
  disposalDate: Date;
  disposalValue: number;
  assetDisposalNominalAccount: number;
  preflight: boolean;
  reverseCurrentYear: boolean;
}

export class AssetDisposalResult {
  asset: Asset;
  result: string;
  message: string;
  journal: JournalEntry;
}

export class AssetConvertToKit {
  assetId: number;
  newChildren: KitChild[] = [];
}

export class KitChild {
  name: string;
  ref: string;
  description: string;
  allocation: number;
}
